import {Row} from 'reactstrap';
import {useEffect, useState} from "react";
import Config from '../Config';
import _ from '../Trans';
import token from "../AuthToken";

const mostValuablePlayersThisWeekText = _('Most valuable players this round');

export default function MostValuablePlayers() {
  const [players, setData] = useState([]);
  const fetchRankingInfo = () => {
    return fetch(Config.mostValuablePlayersUrl, {
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        }
    })
      .then((res) => res.json())
      .then((d) => setData(d.results))
  }

  useEffect(() => {
      fetchRankingInfo();
  }, []);

  if(!players || players.length === 0) {
    return <div>{_('No data available')}</div>
  }

  const isMobile = window.innerWidth <= 767;

  return <Row className="mt-3">
        <div className="col-12 pl-0 pr-0">
            <h3 className="pl-3 most-valuable-players-header pt-3 pb-3 mb-3 h4 font-weight-bold">{mostValuablePlayersThisWeekText}</h3>
        </div>
        <div className="col-12 mb-5">
            <table className="table ranking-striped w-100 mt-3 most-valuable-players" id="most-valuable-players">
                <thead>
                <tr>
                    {!isMobile && <th scope="col">#</th>}
                    {isMobile ? (
                    <th scope="col" colSpan="2" className="text-left">{_('Player')} / {_('Team')}</th>
                    )
                    : (
                    <th scope="col" className="text-left">{_('Player')}</th>
                    )
                    }
                    {!isMobile && <th scope="col"></th>}
                    {!isMobile && <th scope="col">{_('Team')}</th>}
                    <th scope="col" className="text-right">{_('Points')}</th>
                </tr>
                </thead>
                <tbody>
                {players.map((player, index) => <Player key={player.id} player={player} index={index}/>)}
                </tbody>
            </table>
        </div>
    </Row>
}

function Player({player, index}) {
    const isMobile = window.innerWidth <= 767;
    const teamName = _(player.team)

    try {
        return <tr>
            {!isMobile &&
            <td>{index+1}</td>
            }
            <td className="most-valuable-players-image-container text-left">
                <div className="float-left text-left">
                    <img loading="lazy" src={player.image_link} alt="" title="" className="image"/>
                </div>
            </td>
            {isMobile ? (
            <td className="pl-5">
                {player.name} ({player.abbreviation})<br/>
                {teamName}
            </td>
            )
            :
            (
            <td>
                {player.name} ({player.abbreviation})<br/>
            </td>
            )}
            {!isMobile && <td>{teamName}</td>}
            <td className="text-right">{player.latest_points ? player.latest_points : 0}</td>
        </tr>
    }
    catch(e) {
        return <tr><th colSpan={5}></th></tr>
    }
}
